import { render, staticRenderFns } from "./vediodetails.vue?vue&type=template&id=3f688969&scoped=true&"
import script from "./vediodetails.vue?vue&type=script&lang=js&"
export * from "./vediodetails.vue?vue&type=script&lang=js&"
import style0 from "./vediodetails.vue?vue&type=style&index=0&id=3f688969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f688969",
  null
  
)

export default component.exports